import { render, staticRenderFns } from "./CardModalActivity.vue?vue&type=template&id=2dce0e6a&scoped=true"
import script from "./CardModalActivity.vue?vue&type=script&lang=js"
export * from "./CardModalActivity.vue?vue&type=script&lang=js"
import style0 from "./CardModalActivity.vue?vue&type=style&index=0&id=2dce0e6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dce0e6a",
  null
  
)

export default component.exports